import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-type-prise-en-charge.reducer'; // Assurez-vous que le chemin est correct
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParTypePriseEnChargeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, [dispatch, props.match.params.id]);

  const parTypePriseEnChargeEntity = useAppSelector(state => state.parTypePriseEnCharge.entity);

  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parTypePriseEnChargeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.detail.title">ParTypePriseEnCharge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parTypePriseEnChargeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.code">Code</Translate>
            </span>
          </dt>
          <dd>{parTypePriseEnChargeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.name">Name</Translate>
            </span>
          </dt>
          <dd>{parTypePriseEnChargeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.nameAr">NameAr</Translate>
            </span>
          </dt>
          <dd>{parTypePriseEnChargeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.nameEn">NameEn</Translate>
            </span>
          </dt>
          <dd>{parTypePriseEnChargeEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.status">Status</Translate>
            </span>
          </dt>
          <dt>
            <Translate contentKey={`almobadaraMasterDataApp.Status.${parTypePriseEnChargeEntity.status}`} />
          </dt>
          <dd>{parTypePriseEnChargeEntity.status}</dd>
          <dt>
            <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.category">Category</Translate>
          </dt>
          <dd>{parTypePriseEnChargeEntity.category ? parTypePriseEnChargeEntity.category.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/par-type-prise-en-charge" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-type-prise-en-charge/${parTypePriseEnChargeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParTypePriseEnChargeDetail;
